import {Component, EventEmitter, Input, Output,} from '@angular/core';

@Component({
  selector: 'app-shipment-card-button',
  templateUrl: './card-button.component.html',
  styleUrls: ['./card-button.component.scss']
})
export class CardButtonComponent {
  @Input('activeCardName') public activeCardName: string;
  @Input('text') public text: string;
  @Input('cardName') public cardName: string;
  @Output('buttonClicked') buttonClicked = new EventEmitter();

  click() {
    this.buttonClicked.emit(this.cardName);
  }
}
